export default "__VITE_ASSET__DXeaZap5__"